import { computed, defineComponent, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useMessageBox } from '@hems/component';
import VCalendarRange from '@hems/user/src/components/calendar/VCalendarRange.vue';
import { Helper, useModelWrapper, DateHelper } from '@hems/util';
export default defineComponent({
    name: 'CalendarDaily',
    components: {
        VCalendarRange,
    },
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
    },
    setup(props, { emit }) {
        const messageBox = useMessageBox();
        const store = useStore();
        const { t } = useI18n();
        const langCd = computed(() => store.state.appCtx.langCd);
        const locale = Helper.getEnvLocale();
        const state = reactive({
            date: useModelWrapper(props, emit),
        });
        const validateRangeDate = (value) => {
            if (DateHelper.getRangeDate(value) > 31) {
                messageBox.alert(t('message.period_not_exceed')).open();
                return false;
            }
            return true;
        };
        return {
            state,
            Helper,
            validateRangeDate,
            langCd,
            locale,
            DateHelper,
        };
    },
});
